export const SET_STOCK = '17';
export const SET_NAME_SPLIT = '20';
export const SET_CLIENT_ADDRESS_SPLIT = '21';
export const SET_APP_USER = '28';
export const SET_PRODUCTS_PACK = '32';
export const SET_LASER_DCD = '47';
export const SET_LASER_SHOT = '49';
export const SET_APP_NOTASSISTED = '56';
export const SET_CLIENT_PRESCRIPTIONS = '85';
export const SET_APP_USER_FORCE = '87';
export const SET_APP_NOTASSISTED_FUTURE = '101';
export const SET_ORDERS = '118';
export const SET_TIMESLOT = '120';
export const SET_CLIENT_NEW_FIELDS = '125';
export const SET_CLIENT_NEW_REQUIRED_FIELDS = '133';
export const SET_CLIENT_EDIT_REQUIRED_FIELDS = '134';
export const SET_CLIENT_CUSTOMFIELDS_ENABLE = '163';
export const SET_CLIENT_CUSTOMFIELDS_LABELS = '164';
export const SET_SUBSCRIPTIONS = '169';
export const SET_CLIENT_PICTURES_DOWNSCALE = '175';
export const SET_CLIENT_DNI_UNIQUE = '203';
export const SET_CABINET_SKIP = '244';
export const SET_DIARY_FUTURE_VALIDATE = '251';
export const SET_APP_FWA_USER_MODE = '253';
export const SET_APP_COMBINE_FACTOR = '264';
export const SET_RGPD_DISABLE = '267';
export const SET_APP_MAXSERVICES = '277';
export const SET_CLIENT_PHONE_UNIQUE = '278';
export const SET_CLIENT_CUSTOMFIELDS_TYPE_SELECTED = '283';
export const SET_LEGAL_REPRESENTATIVE_AGE = '286';
export const SET_VALIDATE_APP_CLIENT_REQUIRED_FIELDS = '287';
export const SET_LASER_SIGN_ENABLED = '320';
export const SET_CLIENT_MAIL_UNIQUE = '331';
export const SET_DOCTOR_VISUAL = '339';
export const SET_CLIENT_EDIT_HIDE_FIELDS = '342';
export const SET_VOUCHER_PACK_AUTO = '345';
export const SET_STOCK_TRACEABILITY = '349';
export const SET_DIARY_TYPE_DEFAULT = '268';


export enum LASER_SHOT {
    SHOT_SAME_FIELD = -2,
    ACTIVATED_FIELDS,
    DEACTIVATED_FIELDS
}

export enum UNIQUE_RESTRICTIONS {
    NONE, // Can duplicate
    WARNING, // Can duplicate with warning
    FORBIDDEN // Can not duplicate
}
